import { checkError, cloneDeep, isNullOrEmpty, prepareUserDataAndTokenToSave } from '../utils';
import state from './state';
import api from '@/plugins/api';
import { userType } from '@/plugins/enums';

export default {
    signIn({commit}, payload) {
        return new Promise((resolve, reject) => {
            let entity = cloneDeep(payload);
            delete entity.type;

            api.post('auth', entity)
               .then(response => {
                 if (!isNullOrEmpty(response.data.changePassword)) {
                   resolve(response);
                   return;
                 }

                 if (payload.type === state.systemTypes.TENANT_SYSTEM && response.data.user.type === userType.TYPE_SYSTEM) {
                   reject({ data: { message: 'Esse tipo de usuário não está habilitado para usar o App' } });
                 } else if (payload.type === state.systemTypes.TENANT_SYSTEM && response.data.user.type === userType.TYPE_USER && (!response.data.user.hasOwnProperty('tenants') || (response.data.user.tenants.length === 0))) {
                   reject({ data: { message: 'Esse usuário não está vinculado a nenhuma linceça' } });
                 } else {
                   commit('SIGN_IN', prepareUserDataAndTokenToSave(response));
                   resolve(response);
                 }
               })
               .catch(error => {
                 localStorage.removeItem('apiToken');
                 localStorage.removeItem('appUser');
                 sessionStorage.removeItem('apiToken');
                 sessionStorage.removeItem('appUser');
                 checkError(error.response.status);
                 reject(error.response);
               });
        });
    },
    passwordRecovery({commit}, credentials) {
        return new Promise((resolve, reject) => {
          api.post('password/reset', credentials)
             .then(response => {
               resolve(response);
             })
             .catch(error => {
               checkError(error.response.status);
               reject(error.response);
             });
        });
    },
    passwordChange({commit}, credentials) {
        return new Promise((resolve, reject) => {
            api.post('password/change', {password: credentials.password}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + credentials.token,
                },
            }).then(response => {
                resolve(response);
            }).catch(error => {
                checkError(error.response.status);
                reject(error.response);
            });
        });
    },
    updateProfile({commit}, payload) {
        return new Promise((resolve, reject) => {
          api.put(`system/users/${payload.userId}`, payload)
             .then(response => {
               resolve(response);
             })
             .catch(error => {
               checkError(error.response.status);
               reject(error.response);
             });
        });
    },
    getStates({commit}) {
        return new Promise((resolve, reject) => {
          fetch('https://cep.redeforce.app/v1/states?offset=27&fields=id,name,abbreviation')
            .then(response => response.json())
            .then(res => {
              commit('SET_STATES', res.entities);
              resolve(res);
            })
            .catch(error => {
              checkError(error.response.status);
              reject(error.response);
            });
        });
    },
  getCities({ commit }, { state, page = 1 }) {
    return new Promise((resolve, reject) => {
      let query = {
        state,
        page,
      };
      query.fields = 'id,name,state';

      fetch('https://cep.redeforce.app/v1/cities?' + new URLSearchParams(query))
        .then(response => response.json())
        .then(resolve)
        .catch(error => {
          checkError(error.response.status);
          reject(error.response);
        });
    });
  },
    getFileData({commit}, payload) {
        return new Promise((resolve, reject) => {
          api.get(payload.path + '/' + payload.parentId + '/files/' + payload.file)
             .then(response => {
               resolve(response);
             })
             .catch(error => {
               checkError(error.response.status);
               reject(error.response);
             });
        });
    },
};
